import styled from "styled-components";

export const UpdateCardContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 16px;
	background-color: #f8fafc;
	border-radius: 8px;
`;

export const CardProfilePicture = styled.div`
	width: 40px;
	height: 40px;
	background-color: #534b99;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	p {
		text-align: center;
		font-size: 18px;
		line-height: 23px;
		color: #ffffff;
	}
`;

export const CardContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const CardHeaderContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const CardUserName = styled.p`
	font-size: 16px;
	font-weight: 500;
	line-height: 23px;
	color: #31475a;
`;

export const CardDate = styled.p`
	font-size: 14px;
	line-height: 23px;
	color: #62748e;
	margin: 0;
`;

export const CardMessage = styled.p`
	font-size: 14px;
	line-height: 23px;
	color: #31475a;
`;
